/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class KpiPropertyCallbacks
 * @hideconstructor
 * @classdesc This class provides APIs for dashboard avtivity state
 */
define([
	'underscore',
	'jquery',
	'../../../widgets/livewidget/nls/StringResources'
], (_, $, StringResources) => {
	const BASE_SLOT_ID =  'actual';
	const TARGET_SLOT_ID = 'goal';
	/**
	 * this class is used in VisPropertyProvider.
	 */
	class KpiPropertyCallbacks {

		getAPI() {
			// we have to return implementation here. 
			return this;
		}

		_isSlotMapped(slot) {
			const dataItems = slot && slot.getDataItemList() || [];
			return dataItems.length > 0;
		}

		_getDataItem(slot, dataItemIndex = 0) {
			return slot.getDataItemList()[dataItemIndex];
		}

		preRenderBaseLabelProperty(_content) {
			let updatedSettings = {};
			const baseSlot = _content.getFeature('Visualization').getSlots().getSlot(BASE_SLOT_ID);
			if (this._isSlotMapped(baseSlot)) {
				const dataItem = this._getDataItem(baseSlot);
				updatedSettings.placeHolderText = _.escape(dataItem.getLabel());
			} else {
				updatedSettings.placeHolderText = '';
			}

			return updatedSettings;
		}

		preRenderTargetLabelProperty(_content) {
			let updatedSettings = {};
			const targetSlot = _content.getFeature('Visualization').getSlots().getSlot(TARGET_SLOT_ID);
			if (this._isSlotMapped(targetSlot)) {
				const dataItem = this._getDataItem(targetSlot);
				updatedSettings.placeHolderText = _.escape(dataItem.getLabel());
			} else {
				updatedSettings.placeHolderText = _.escape(StringResources.get('kpiDefaultTargetLabel'));
			}

			return updatedSettings;
		}

		_getFormatForSlot(visualization, slot) {
			const dataItem = this._getDataItem(slot);
			const format = dataItem && dataItem.getFormat();
			return format || {};
		}

		preRenderTargetValueProperty(_content) {
			let updatedSettings = {};
			const visualization = _content.getFeature('Visualization.internal');
			const targetSlot = visualization.getSlots().getSlot(TARGET_SLOT_ID);
			const baseSlot = visualization.getSlots().getSlot(BASE_SLOT_ID);

			if (this._isSlotMapped(targetSlot)) {
				updatedSettings.readOnly = true;
				updatedSettings.disabled = true;
				updatedSettings.placeHolderText = _.escape(StringResources.get('kpiManualTargetSlotFilled'));
				updatedSettings.value = '';
			} else if (baseSlot) { // If we have decimal places in the format, allow the user to enter that many decimal places in the target.
				const formatSpec = this._getFormatForSlot(visualization, baseSlot);
				const decimalPlaces = Math.max(formatSpec.maximumFractionDigits || 0, formatSpec.minimumFractionDigits || 0);
				if (decimalPlaces) {
					updatedSettings.decimalPlaces = decimalPlaces;
				}
			}

			return updatedSettings;
		}

		preRenderValueSizeProperty(_content, property) {
			let update = {
				options: property.options,
				removeProperty: true  //if we remove 'removeProperty' here, we should reimplement onChangeValueSizeProperty()
			};

			if (update.options[0].value === 'auto') {
				update.options[0].label = StringResources.get('kpiAutoValueSize');
			}

			return update;
		}

		onChangeValueSizeProperty(_content, propertyName, propertyValue) {
			void(propertyName);
			void(propertyValue);
			/**
			 * The property is not using now since we set "removeProperty:true".
			 * [todo] if we want to re-enable the property, we should directly use widgetModel.properties...
			 * There is an example in VisPropertyPropvider.
			 */
			/*
			let props = {};
			if (propertyValue === 'auto') {
				props['baseValueSize'] = 'auto';
				props['targetValueSize'] = 'auto';
			} else {
				props['baseValueSize'] = _content.getPropertyValue('baseValueSize');
				props['targetValueSize'] = _content.getPropertyValue('targetValueSize');
				if (props['baseValueSize'] === 'auto') {
					props['baseValueSize'] = '32';
					props['targetValueSize'] = '16';
				}
				props[propertyName] = propertyValue;
			}
			const transactionId = _.uniqueId('kpi_font_size');
			const ownerWidget = _content.getFeature('livewidget.internal').getWidget();
			for (let property in props) {
				ownerWidget.onPropertyUpdate({
					'category': property,
					'item': props[property],
					'transactionId': transactionId
				});
			}*/
		}

		validateTargetValueProperty(_content, value) {
			let valid = $.isNumeric(value) || !value;
			return {
				isValid: valid,
				message: StringResources.get('kpiNonNumericTarget')
			};
		}

	}
	return KpiPropertyCallbacks;
});